import { Checkbox, Table, TableCell, TableRow, styled, Box, Icon, Grid, InputLabel } from '@mui/material';
import { Card, Dialog, Typography, CollapseCard } from '@totalsoft/rocket-ui';
import { withPropsExclusion } from 'utils/functions';

export const ThinCheckbox = styled(Checkbox)(({ theme }) => ({
  padding: theme.spacing(0.5)
}));

export const StyledHeaderCell = styled(TableCell)(({ theme }) => ({
  fontWeight: theme.typography.fontWeightBold,
  paddingLeft: theme.spacing(3),
  paddingBlock: theme.spacing(3),
  whiteSpace: 'nowrap',
  textOverflow: 'ellipsis',
  overflow: 'hidden'
}));

export const StyledTableRow = styled(TableRow)(() => ({
  height: '60px'
}));

export const StyledGrid = styled(Grid)(() => ({
  justifyContent: 'space-between',
  paddingTop: '40px'
}));

export const StyledActionHeaderCell = styled(StyledHeaderCell)(() => ({
  width: '170px'
}));

export const StyledOrderHeaderCell = styled(StyledHeaderCell)(() => ({
  width: '150px'
}));

export const StyledTableBodyCell = styled(TableCell)(({ theme }) => ({
  paddingLeft: theme.spacing(3),
  paddingBlock: 0
}));

export const StyledTable = styled(Table)(({ minWidth }) => ({
  tableLayout: 'fixed',
  minWidth: minWidth
}));

export const StyledGrayIcon = styled(Icon, { shouldForwardProp: prop => prop !== 'hasError' })(({ hasError, theme }) => ({
  color: hasError ? theme.palette.error.main : 'rgba(0, 0, 0, 0.6)'
}));

export const NavPillsCardContainer = styled(
  Card,
  withPropsExclusion(['px', 'py', 'p'])
)(({ theme, px, py, p }) => ({
  '& .MuiBox-root[role=tab-panel] > .MuiBox-root': {
    padding: 0,
    overflowX: 'auto'
  },
  '& > .MuiCardContent-root': {
    padding: `${p && theme.spacing(p)} !important`,
    paddingInline: `${px && theme.spacing(px)} !important`,
    paddingBlock: `${py && theme.spacing(py)} !important`
  }
}));

export const NavPillsBoxContainer = styled(Box, { shouldForwardProp: prop => !['panelOverflow'].includes(prop) })(({ panelOverflow }) => ({
  '& > [role=tab-panel] > .MuiBox-root': {
    padding: 0,
    overflow: panelOverflow || 'auto'
  }
}));

export const StyledTableContainer = styled(Box)(() => ({
  overflowX: 'auto'
}));

export const FixedTable = styled(Table)(() => ({
  tableLayout: 'fixed'
}));

export const UnpaddedDialog = styled(Dialog)(() => ({
  '& .MuiDialogContent-root': {
    padding: 0
  }
}));

export const CompactTitle = styled(Typography)(({ theme }) => ({
  [theme.breakpoints.down('sm')]: {
    whiteSpace: 'nowrap'
  }
}));

export const FormulaFieldContainer = styled(Box)(({ theme }) => ({
  paddingInline: theme.spacing(0.5),
  paddingBlock: theme.spacing(0.5),
  marginInline: theme.spacing(0.5),
  marginBlock: theme.spacing(1),
  boxShadow: theme.shadows[5],
  borderRadius: theme.spacing(1)
}));

export const FormulaParamsCollapseCard = styled(CollapseCard)(({ theme }) => ({
  backgroundColor: theme.palette.grey[100],
  '& .MuiCardHeader-root': {
    paddingBlock: theme.spacing(1)
  },
  '& .MuiCardContent-root': {
    paddingBlock: '0 !important',
    paddingInline: theme.spacing(1)
  },
  '& th, td': {
    paddingBlock: theme.spacing(0.75),
    fontSize: '14px'
  }
}));

export const FormulaFieldLabel = styled(InputLabel)(({ theme }) => ({
  fontFamily: 'Source Sans Pro',
  fontSize: 14,
  lineHeight: 1.42857,
  fontWeight: 400,
  color: theme.palette.text.primary
}));
